import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import DesktopDashboardPage from './logged/DesktopDashboardPage';
import DisabledPage from './logged/DisabledPage';
import store from '../store/index';
import { getPupilMenuItems } from './PupilMenuItems';
import {
  checkDefaultViewForPupil,
  getDefaultViewForPupil,
} from '../helpers';
import ErrorBoundary from './parts/Error/ErrorBoundary';

const styles = theme => ({
  loadingWrapper: {
    padding: 24,
    textAlign: 'center',
  },
});

function PageContainer({ children }) {
  return (
    <div style={{
      maxWidth: 1080,
      padding: 24,
      margin: '0 auto',
    }}
    >
      {children}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    messagesSelectedThread: state.messagesSelectedThread,
    selectedPupil: state.selectedPupil,
    openModal: state.openModal,
    user: state.user,
  };
};

// TODO: use react-redux, instead of that updateView() thing
class DesktopLoggedPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pupilId: 0,
      view: appType === 'parent'
        ? 'dashboard'
        : 'loading',
    };

    this.updateView = this.updateView.bind(this);
  }

  componentDidMount() {
    this.updateView();
    this.storeSubscription = store.subscribe(() => {
      this.updateView();
    });
  }

  componentWillUnmount() {
    if (this.storeSubscription) {
      this.storeSubscription();
    }
  }

  updateView() {
    const storeState = store.getState();
    const { selectedPupil } = storeState;
    const isPupilSelected = selectedPupil !== null;

    if (
      !isPupilSelected &&
      appType === 'student'
    ) {
      // This scenario musn't ever happen
      return;
    }

    if (
      isPupilSelected &&
      !selectedPupil.defaultView
    ) {
      selectedPupil.defaultView = getDefaultViewForPupil(selectedPupil);
    }

    if (
      isPupilSelected &&
      selectedPupil.defaultView
    ) {
      selectedPupil.defaultView = checkDefaultViewForPupil(selectedPupil);

      let hash = `${selectedPupil.id},${selectedPupil.defaultView}`;
      if (storeState.openModal) {
        hash += ',' + storeState.openModal;
      } else {
        const hashSplit = window.location.hash.split(',');
        if (
          typeof hashSplit[2] !== 'undefined'
        ) {
          hash += ',' + hashSplit[2];
        }
      }
      window.location.hash = hash;

      this.setState({
        pupilId: selectedPupil.id,
        view: selectedPupil.defaultView,
      });
    } else if (
      !isPupilSelected &&
      appType === 'parent' &&
      (
        window.location.hash === '' ||
        window.location.hash === '#'
      )
    ) {
      this.setState({
        pupilId: 0,
        view: 'dashboard',
      });
    }
  }

  render() {
    const {
      classes,
      selectedPupil,
      user,
    } = this.props;
    const {
      view,
      pupilId,
    } = this.state;

    const views = selectedPupil
      ? getPupilMenuItems(selectedPupil, user, '', true)
      : {};

    return (
      <ErrorBoundary location="DesktopLoggedPage.js">
        {view === 'loading' && (
          <div className={classes.loadingWrapper}>
            <CircularProgress />
          </div>
        )}
        {view === 'dashboard' && (
          <PageContainer>
            <DesktopDashboardPage key={pupilId} useSuspense={false} />
          </PageContainer>
        )}
        {Object.keys(views).map((key) => {
          if (key !== view) {
            return null;
          }

          if (views[key].desktopWithoutContainer) {
            return (
              <ErrorBoundary key={key} location={`DesktopLoggedPage.js, tab:${key}`}>
                {views[key].component}
              </ErrorBoundary>
            );
          }

          return (
            <ErrorBoundary key={key} location={`DesktopLoggedPage.js, tab:${key}`}>
              <PageContainer>{views[key].component}</PageContainer>
            </ErrorBoundary>
          );
        })}
        {view === 'disabled' && (
          <PageContainer>
            <DisabledPage key={pupilId} useSuspense={false} />
          </PageContainer>
        )}
      </ErrorBoundary>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(DesktopLoggedPage)
);
